import React from 'react';
import {
  DateTimePicker,
  DateTimePickerProps,
  MuiPickersUtilsProvider,
} from '@material-ui/pickers';
import { BaseTextField } from '../BaseTextField/BaseTextField';
import DateFnsUtils from '@date-io/date-fns';
import CalendarIco from './calendar-ico.png';
import { IconButton, InputAdornment } from '@material-ui/core';

type PBaseDateTimePicker = DateTimePickerProps & {
  InputProps?: any;
  errorText?: string;
};

export const BaseDateTimePicker: React.FC<PBaseDateTimePicker> = (props) => {
  const { onChange, value, errorText, InputProps = {}, ...otherProps } = props;
  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <DateTimePicker
        inputVariant="outlined"
        value={value || null}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <IconButton>
                <img src={CalendarIco} alt="Calendar" />
              </IconButton>
            </InputAdornment>
          ),
          ...InputProps,
        }}
        // DateTimePicker cant pass errorText straight to BaseTextField
        // because DateTimePicker works well only with MaterialUI TextField component
        // That is why I pass error and helperText props and handle them in BaseTextField component
        error={Boolean(errorText)}
        helperText={errorText}
        onChange={onChange}
        // @ts-ignore
        TextFieldComponent={BaseTextField}
        {...otherProps}
      />
    </MuiPickersUtilsProvider>
  );
};
